import { render, staticRenderFns } from "./pransition-page.vue?vue&type=template&id=19841e58&"
import script from "./pransition-page.vue?vue&type=script&lang=js&"
export * from "./pransition-page.vue?vue&type=script&lang=js&"
import style0 from "./pransition-page.vue?vue&type=style&index=0&id=19841e58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports